import React, { useRef } from 'react';

interface RecapItem {
    label: string;
    value: string;
}

export interface RecapItems extends Array<RecapItem> {}

interface RecapProps {
    items: RecapItems;
    title: string;
    mobileRecapDisplay?: 'collapsed' | 'expanded' | 'sticky';
}

export class BookprocessRecap extends React.Component<RecapProps, {}> {
    private wrapperRef = React.createRef<HTMLDivElement>();

    trustedHtml(val: any) {
        return { __html: val };
    }

    render() {
        if (this.props.items.length === 0) {
            return React.createElement('aside', {});
        }
        let recapInfoElements = this.props.items.map((info, idx) => {
            return [
                React.createElement('dt', { key: 'label' + idx }, info.label),
                React.createElement('dd', {
                    key: 'value' + idx,
                    dangerouslySetInnerHTML: this.trustedHtml(info.value),
                }),
            ];
        });
        let titleEle = React.createElement(
            'h2',
            {
                onClick: () => {
                    if (this.wrapperRef) {
                        this.wrapperRef.current.classList.toggle('recapShown');
                    }
                },
            },
            null,
            this.props.title
        );
        let recapEle = React.createElement('dl', { className: 'recapEle' }, recapInfoElements);
        let wrapperClasses = 'recapWrapper';
        if (this.props.mobileRecapDisplay === 'expanded') {
            wrapperClasses += ' recapShown';
        }
        if (this.props.mobileRecapDisplay === 'sticky') {
            wrapperClasses += ' recapSticky';
        }
        let wrapperEle = React.createElement(
            'div',
            { className: wrapperClasses, ref: this.wrapperRef },
            titleEle,
            recapEle
        );
        return React.createElement('aside', {}, wrapperEle);
    }
}
